import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { BinaTreeModel } from '@data-layer/models/common';
import { BINA_FIFTH_GROUP_NUM, BINA_FIRST_GROUP_NUM, BINA_FOURTH_GROUP_NUM, BINA_SECOND_GROUP_NUM, BINA_THIRD_GROUP_NUM } from '../const';

@Component({
  selector: 'bina-proposal',
  templateUrl: './bina-proposal.component.html',
  styleUrls: ['./bina-proposal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinaProposalComponent {
  @Input() public htsCode: string;
  @Input() public firstText: string;
  @Input() public secondText: string;
  @Input() public options: BinaTreeModel;
  @Input() public selectedHTS: string[] = [];
  @Input() public isShowInsertCode: boolean;
  @Input() public isShowAddToCatalog: boolean;
  @Input() public isShowPath: boolean;
  @Output() public optionClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() public subGroupClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() public htsInsert: EventEmitter<void> = new EventEmitter<void>();
  @Output() public addHtsToCatalog: EventEmitter<void> = new EventEmitter<void>();

  public BINA_FIRST_GROUP_NUM: number = BINA_FIRST_GROUP_NUM;
  public BINA_SECOND_GROUP_NUM: number = BINA_SECOND_GROUP_NUM;
  public BINA_THIRD_GROUP_NUM: number = BINA_THIRD_GROUP_NUM;
  public BINA_FOURTH_GROUP_NUM: number = BINA_FOURTH_GROUP_NUM;
  public BINA_FIFTH_GROUP_NUM: number = BINA_FIFTH_GROUP_NUM;

  public isCopied: boolean;

  constructor(private cdr: ChangeDetectorRef) {}

  public codeGroupAt(indexEnd: number): string {
    return !!this.htsCode?.[indexEnd - 2] && !!this.htsCode?.[indexEnd - 1]
      ? this.htsCode[indexEnd - 2] + this.htsCode[indexEnd - 1]
      : null;
  }

  public isOptionSelected(option: any): boolean {
    return this.selectedHTS.includes(option) || !!this.selectedHTS.find((item: string) => item.startsWith(option));
  }

  public selectHTS(htsCode: string): void {
    if (this.selectedHTS.includes(htsCode)) {
      return;
    }

    this.optionClick.emit(htsCode);
  }

  public a(): void {
    this.cdr.markForCheck();
  }

  public async copyToClipboard(): Promise<void> {
    await navigator.clipboard.writeText(this.htsCode);
    this.isCopied = true;
    this.cdr.markForCheck();
  }

  public resetCopyText(): void {
    this.isCopied = false;
  }

  public get formattedOptions(): Array<{ [key: string]: string }> {
    if (!this.options) {
      return;
    }
    const keys: string[] = Object.keys(this.options) || [];
    return keys.map((item: string) => ({ hts: item, description: this.options?.[item] }));
  }

  public get isFullHTS(): boolean {
    if (!this.htsCode) {
      return;
    }
    return this.htsCode.length === BINA_FIFTH_GROUP_NUM;
  }

  public get titleLength(): string {
    if (!this.htsCode) {
      return;
    }

    const itemHalfWidth: number = 14;
    const itemDelimiterWidth: number = 5;
    const itemsCountRation: number = 2;
    let itemsDotMargin: number = 0;
    if (this.htsCode.length > BINA_SECOND_GROUP_NUM) {
      itemsDotMargin += itemDelimiterWidth;
    }
    if (this.htsCode.length > BINA_FOURTH_GROUP_NUM) {
      itemsDotMargin += itemDelimiterWidth;
    }

    return this.htsCode.length * itemHalfWidth + itemsDotMargin + this.htsCode.length / itemsCountRation + 'px';
  }
}
